var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-container",domProps:{"innerHTML":_vm._s(require(("!html-loader!../../../assets/icons/svg/" + _vm.icon + ".svg")))}})}
var staticRenderFns = []

export { render, staticRenderFns }